import { defineStore } from "pinia";
import { asyncRoutes, constantRoutes, errorRoutes } from "@/router/index";
import { groupsByUserId } from "@/service/permission";
import { useCounterStore } from "@/store/user";
function hasPermission(roles, route) {
    const userStore = useCounterStore();
    const userInfo = userStore.getUserInfo;
    if (route.meta && route.meta.alliance_type) {
        if (route.meta.alliance_type.includes(userInfo.alliance_type)) {
            return true;
        }
        else {
            return false;
        }
    }
    if (route.meta && route.meta.roles) {
        try {
            return roles.some((role) => (route.meta?.roles).includes(role));
        }
        catch { }
    }
    else {
        return true;
    }
}
export function filterAsyncRoutes(routes, roles) {
    const res = [];
    routes.forEach((route) => {
        const tmp = { ...route };
        if (hasPermission(roles, tmp)) {
            if (tmp.children) {
                tmp.children = filterAsyncRoutes(tmp.children, roles);
            }
            res.push(tmp);
        }
    });
    return res;
}
export const permissionStore = defineStore("permission", {
    state: () => ({
        routes: [],
        addRoutes: [],
        subPermissions: [],
        activePlatform: sessionStorage.getItem("platform")
    }),
    getters: {
        getRoutes(state) {
            return state.routes;
        },
        getAddRoutes(state) {
            return state.addRoutes;
        },
        getSubPermissions(state) {
            return state.subPermissions;
        }
    },
    actions: {
        fetchSubPermissions() {
            return new Promise((resolve) => {
                groupsByUserId().then((res) => {
                    this.subPermissions = res.data;
                    resolve(res.data);
                });
            });
        },
        resetRouter() {
            this.routes = [];
            this.addRoutes = [];
        },
        generateRoutes(roles) {
            return new Promise((resolve) => {
                const accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);
                this.addRoutes = accessedRoutes;
                this.routes = constantRoutes.concat(accessedRoutes).concat(errorRoutes);
                resolve(this.routes.concat(errorRoutes));
            });
        }
    }
});
